<p-toast baseZIndex="5000"></p-toast>
<div style='text-align:center'>
    <h2>Aprobado</h2>

    <p-table [value]="[{}]" class="tablawidth">
        <ng-template pTemplate="body">
            <tr>
                <td>Orden de compra:</td>
                <td>{{ data.datos.RespuestaWebpay.respuesta.commitResponse.buy_order }}</td>
            </tr>
            <tr>
                <td>Id de sesión:</td>
                <td>{{ data.datos.RespuestaWebpay.respuesta.commitResponse.session_id }}</td>
            </tr>
            <tr>
                <td>Monto:</td>
                <td>{{ data.datos.RespuestaWebpay.respuesta.commitResponse.amount }}</td>
            </tr>
            <tr>
                <td>Final número de tarjeta:</td>
                <td>{{ data.datos.RespuestaWebpay.respuesta.commitResponse.card_detail.card_number }}</td>
            </tr>
            <tr>
                <td>Tipo de pago:</td>
                <td>{{ data.datos.RespuestaWebpay.respuesta.commitResponse.payment_type_code }}</td>
            </tr>
            <tr>
                <td>Cuotas:</td>
                <td>{{ data.datos.RespuestaWebpay.respuesta.commitResponse.installments_number }}</td>
            </tr>
            <tr>
                <td>Código de autorización:</td>
                <td>{{ data.datos.RespuestaWebpay.respuesta.commitResponse.authorization_code }}</td>
            </tr>
        </ng-template>
    </p-table>
    <div>
        <p class="observacion">
            Dudas o consultas de WebPay acerca del pago, boleta, devolución o
            reembolsos, etc; comuníquese ingresando a https://aranceles.uv.cl, también
            a través del email finanzas.recaudacion@uv.cl o al fono (032) 2507237.
        </p>
    </div>
    <div>
        <div>

            <button pButton type="button" label="Volver" (click)="volver()" class="me-1 p-button-sm"></button>

            <br /><br />

            <form [formGroup]="miFormulario" style="display: inline-block;" (ngSubmit)="onSubmit()" method="POST">
                <div class="p-formgroup-inline">
                    <input type="hidden" name="datos" formControlName="datos" />
                    <div class="p-field">
                        <span class="p-buttonset">

                            <input id="email" type="email" class="p-inputtext-sm quita-borde-elemento-derecha"
                                formControlName="correo" pInputText placeholder="Ingrese su correo">
                            <button pButton type="submit" class="p-button-sm bordea-elemento-derecha"
                                label="Enviar Correo" [disabled]="!miFormulario.valid"></button>
                        </span>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>